import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export const LoginFailed = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const message = urlParams.get("message");
    const status = urlParams.get("status");

    if (status === "403") {
      toast.error(decodeURIComponent(message || "Account is deleted."));
    } else {
      toast.error(decodeURIComponent(message || "Login failed."));
    }

    // Redirect back to login after showing toast
    setTimeout(() => {
      navigate("/registration_login");
    }, 2000);
  }, []);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2>Redirecting...</h2>
    </div>
  );
};


